<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-square-clockwise-spin"
  [fullScreen]="true"
  ><p style="color: white">Processing. Please Wait....</p></ngx-spinner
>
<router-outlet></router-outlet> 